<template>
    <div class="flex-grow-1 d-flex flex-column flex-md-row flex-wrap gap-1 justify-content-end">
        <OrderListFilter>
            <template v-slot:label>
                {{ __('general.filter') }}: {{ __('general.type') }}
            </template>
            <OrderTypeSelect :value="initSelectedOrderTypes" @input="updateOrderTypeFilter"/>
        </OrderListFilter>
        <OrderListFilter>
            <template v-slot:label>
                {{ __('general.filter') }}: {{ __('general.date') }}
            </template>
            <DateRangeSelect :value="initRange" @input="updateDateRange"/>
        </OrderListFilter>
        <OrderListFilter>
            <template v-slot:label>
                {{ __('general.filter') }}: {{ __('general.status') }}
            </template>
            <OrderStateSelect :value="initOrderStates" @input="updateSelectedOrderStates"/>
        </OrderListFilter>
        <OrderListFilter>
            <template v-slot:label>
                <i class="fas fa-search d-none d-md-inline-block"/>
                {{ __('actions.order.search') }}
            </template>
            <div class="input-group">
                <input type="text"
                       class="form-control w-md-200px w-lg-250px"
                       :placeholder="__('orders.search_placeholder')"
                       :value="initSearch"
                       @change="e => startSearch(e.target.value)">
                <div v-if="initSearch && initSearch.length > 0" class="input-group-append">
                    <button class="btn btn-light-danger" @click="startSearch('')">
                        <i class="fas fa-times-circle"/>
                    </button>
                </div>
            </div>
        </OrderListFilter>
    </div>
</template>

<script>
import DateRangeSelect from "@components/Form/DateRangeSelect.vue";
import OrderListFilter from "@components/Orders/Controls/OrderListFilter.vue";
import OrderStateSelect from "@components/Form/OrderStateSelect.vue";
import OrderTypeSelect from "@components/Form/OrderTypeSelect.vue";
import {rewriteUrlNew} from "@composables/rewriteUrlNew";

export default {
    components: {DateRangeSelect, OrderListFilter, OrderStateSelect, OrderTypeSelect},

    props: {
        initSearch: String,
        initRange: Object,
        initOrderStates: Array,
        initSelectedOrderTypes: Object
    },

    methods: {
        updateDateRange(range) {
            if (range.start !== undefined || range.end !== undefined) {
                rewriteUrlNew('range', range);
            } else {
                rewriteUrlNew('range', '')
            }
            this.updateTableData();
        },

        updateOrderTypeFilter(orderTypes) {
            rewriteUrlNew('types', orderTypes)
            this.updateTableData();
        },

        updateSelectedOrderStates(selectedStates) {
            rewriteUrlNew('states', selectedStates)
            this.updateTableData();
        },

        startSearch(value){
            rewriteUrlNew('search', value)
            this.updateTableData();
            this.$emit('searchStarted', value)
        },

        updateTableData() {
            this.$emit('reloadOrders')
        }
    }
}
</script>
